export const CAMPOS_COMPENSADA = [
    { campo: "colunaNumeroDocumento", label: "Nº documento" },
    { campo: "colunaDivisao", label: "Divisão" },
    { campo: "colunaValor", label: "Valor" },
    { campo: "colunaTexto", label: "Texto" },
    { campo: "colunaReferencia", label: "Referência" },
    { campo: "colunaAtribuicao", label: "Atribuição" },
    { campo: "colunaDataDocumento", label: "Data do documento" },
    { campo: "colunaDataEntrada", label: "Data de entrada" },
    { campo: "colunaDataPagamento", label: "Data de pagamento" },
    { campo: "colunaDataCompensacao", label: "Data de compensação" },
    { campo: "colunaCodigoFornecedor", label: "Código Fornecedor" },
];

export function letraColuna(indice) {
    let n = indice;
    let letra = "";
    do {
        letra = String.fromCharCode(65 + (n % 26)) + letra;
        n = Math.floor(n / 26) - 1;
    } while (n >= 0);
    return letra;
}

export function mapeamentoCompleto(mapeamento) {
    if (!mapeamento) return false;
    return CAMPOS_COMPENSADA.every(c => mapeamento[c.campo] !== null && mapeamento[c.campo] !== undefined && mapeamento[c.campo] !== "");
}
